import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderAutoRateLookup extends Layout {
    sourceRateLookup: DataSource;
    tableRateLookup: Table;
}
